import { InputSelect, TextArea, TextField } from "components";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { defaultSprintValues, sprintStatus } from "utils";

interface IModalEdit {
    onClose: () => void;
    onConfirm?: (a: any) => void;
    item?: any;
}
export default function SprintForm({ onClose, onConfirm, item }: IModalEdit) {

    const {
        register,
        control,
        handleSubmit,
    } = useForm({ defaultValues: item ?? defaultSprintValues });

    return (
        <div className="mx-auto bg-white rounded-lg  ">
            <div className="content-modal p-4">
                <div className="grid md:grid-cols-3 gap-3 grid-cols-1">
                    <div>
                        <label className="block font-medium mb-1">Tên:</label>
                        <TextField
                            type="text"
                            placeholder="Nhập họ tên"
                            {...register("name")}
                        />
                    </div>
                    <div className="shadow-none w-50">
                        <label className="block font-medium mb-1">Trạng thái:</label>
                        <Controller
                            control={control}
                            name="status"
                            render={({ field }) => (
                                <InputSelect options={sprintStatus} {...field} />
                            )}
                        />
                    </div>
                    <div>
                        <label className="block font-medium mb-1">Mô tả:</label>
                        <Controller
                            control={control}
                            name="description"
                            render={({ field }) => (
                                <TextArea
                                    {...field}
                                    placeholder="Nhập mô tả ngắn..."
                                    {...register("description")}
                                    rows={3}
                                />
                            )}
                        />
                    </div>
                    <div className="">
                        <label className="block font-medium mb-1">Ngày bắt đầu</label>
                        <Controller
                            control={control}
                            name="start_date"
                            render={({ field }) => (
                                <TextField type="date"  {...field} />
                            )}
                        />
                    </div>
                    <div className="">
                        <label className="block font-medium mb-1">Ngày kết thúc</label>
                        <TextField type="date" {...register("end_date")} />
                    </div>
                </div>

            </div>
            <div className="flex justify-center gap-2 p-4">
                <button
                    onClick={onClose}
                    className="bg-gray-500 text-white px-4 py-1 rounded hover:bg-gray-600"
                >
                    Huỷ
                </button>
                {!!onConfirm && <button
                    onClick={() => handleSubmit(onConfirm)()}
                    className="bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600"
                >
                    Xác nhận
                </button>}
            </div>
        </div>
    );
}
